module.exports = __webpack_public_path__ + "static/communication-35df79c0bc822cb96f5bc2218645d67b.png";